import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Shop from './pages/Shop/Shop';
import ProductDetail from './pages/ProductDetail/ProductDetail';
import Checkout from './pages/Checkout/Checkout';
import TrackOrder from './pages/TrackOrder/TrackOrder';

import { CartProvider, useCart } from './context/CartContext';
import CartDrawer from './components/CartDrawer/CartDrawer'; 
import About from './pages/About';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Warranty from './pages/Warranty';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
function AppLayout() {
  const { isCartOpen, setIsCartOpen, cart } = useCart();

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <CartDrawer
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        cartItems={cart}
      />

      <main className="flex-1 pt-16 " dir="rtl">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:slug" element={<ProductDetail />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/track" element={<TrackOrder />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/warranty" element={<Warranty />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <CartProvider>
      <AppLayout />
    </CartProvider>
  );
}